<div class="page tracking history">

  <app-left-track [trackingMode]="false" [visibleComponents]="'drivers geozones'"></app-left-track>

  <div class="vert_collapser" id="vert_collapser" onclick="collapseTrack()">
    <span><i></i></span>
  </div>

  <div class="righttrack">
    <div class="topright" id="topright">
      <simple-map [mapMode]="'history'"></simple-map>
    </div>
    <div (mousedown)="splitterDown()" class="hor_splitter" id="hor_right_splitter">
      <span></span>
    </div>

    <div class="bottomright" id="bottomright">
      <div class="btns">
        <div class="btn_tabs">
          <button (click)="this.openTabTrackingRight('table_drivers_stat', 1)">{{'Statistics'|translate }}</button>
          <button (click)="this.openTabTrackingRight('table_info', 2)">{{'Track'|translate }}</button>
          <button (click)="this.openTabTrackingRight('table_violations', 3)">{{'Violations'|translate }}</button>
        </div>
        <div>
          <input type="text" class="dtpickerupleft" value="20.08.2017 10:30 - 28.08.2017 14:05" />
        </div>
        <button id="setintervalbtn" class="btn_blue">{{'Apply'|translate }}</button>
        <button class="btn_img btn_graygray btn_down" (click)="this.collapseRightBottom()"></button>
      </div>
      <div class="bottomrighttables" id="bottomright_tables">
        <app-drivers-stat></app-drivers-stat>
        <app-track-info-with-violations></app-track-info-with-violations>
        <app-violations-list></app-violations-list>
      </div>
    </div>
  </div>
</div>
